var _defs, _path, _path2, _path3, _path4, _polygon, _path5, _polygon2, _polygon3, _polygon4, _path6, _polygon5, _path7, _polygon6, _path8, _path9, _path10, _rect, _rect2, _rect3, _rect4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSignature2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 2000 2000",
    "data-name": "Layer 2",
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#4d4c78;}.cls-2{fill:#67baeb;}.cls-3{fill:#de3226;}.cls-4{fill:#231f20;}.cls-5{fill:#f4c23f;}.cls-6{fill:#b9b1e0;}.cls-7{fill:#46a1f8;}.cls-8{fill:#b11a31;}.cls-9{fill:#f4a93f;}.cls-10{fill:#b1a9d6;}.cls-11{fill:#83d0fb;}.cls-12{fill:#fad564;}.cls-13{fill:#f44533;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1358.2,830.7H1254.3a20,20,0,0,1,0-40h103.9a20,20,0,0,1,0,40Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1053.8,1298.4a20.2,20.2,0,0,1-19.3-14.5,190.8,190.8,0,0,1-7.2-51.6c0-103.1,83.9-187,187-187h282.8A107.5,107.5,0,0,0,1604.5,938c0-59.1-48.2-107.3-107.4-107.3h-67.3a20,20,0,0,1,0-40h67.3c81.3,0,147.4,66.1,147.4,147.3s-66.1,147.3-147.4,147.3H1214.3c-81.1,0-147,66-147,147a146.4,146.4,0,0,0,5.7,40.6,20,20,0,0,1-13.7,24.7A21.5,21.5,0,0,1,1053.8,1298.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1430.7,1806.7H650.4a20,20,0,1,1,0-40h780.3c95.8,0,173.8-77.9,173.8-173.7s-78-173.8-173.8-173.8H1214.3a186.1,186.1,0,0,1-136.3-58.9,20,20,0,0,1,29.2-27.4,145.3,145.3,0,0,0,107.1,46.3h216.4a213.8,213.8,0,0,1,0,427.5Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M575,1806.7H478.4a20,20,0,1,1,0-40H575a20,20,0,0,1,0,40Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "915.7 516.6 618.3 1626.2 405.5 1569.2 700.5 468.5 913.3 525.5 915.7 516.6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M738.9,324.9A110.3,110.3,0,0,1,873.8,247h0a110.1,110.1,0,0,1,77.9,134.9l-16.4,61.5-212.8-57Z"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "700.5 468.5 722.5 386.4 722.5 386.4 700.5 468.5 700.5 468.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "915.7 516.6 935.3 443.4 935.3 443.4 915.7 516.6"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "913.3 525.5 700.5 468.5 722.5 386.4 935.3 443.4 915.7 516.6 913.3 525.5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M618.3,1626.2l-212.8-57,33.8,218c3.1,19.8,28.2,26.5,40.8,10.9Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "618.3 1626.2 562.3 1611.2 857.2 510.5 913.3 525.5 915.7 516.6 618.3 1626.2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M722.5,386.4h0l156.7,42,16.5-61.5a110.2,110.2,0,0,0-50.9-123.6,107.4,107.4,0,0,1,29,3.7h0a110.1,110.1,0,0,1,77.9,134.9l-16.4,61.5Z"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "857.2 510.5 859.6 501.6 879.2 428.4 935.3 443.4 915.7 516.6 913.3 525.5 857.2 510.5"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M439.3,1787.2l-3-19.4,126-156.6,56,15L480.1,1798.1C467.5,1813.7,442.4,1807,439.3,1787.2Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M750.3,762.8a20,20,0,0,0-36.6,4.8L534.8,1435.2a20,20,0,0,0,38.6,10.4L752.3,778A19.9,19.9,0,0,0,750.3,762.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M791.1,610.4a19.8,19.8,0,0,0-12.1-9.3,20,20,0,0,0-24.5,14.2l-19.3,72a20,20,0,0,0,38.6,10.4l19.3-72.1A20,20,0,0,0,791.1,610.4Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 278.37,
    rx: 24.6,
    ry: 24.6,
    transform: "translate(317.3 -101) rotate(15)",
    width: 49.1,
    x: 517.8,
    y: 1015.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    height: 106.15,
    rx: 24.6,
    ry: 24.6,
    transform: "translate(258.3 -125.5) rotate(15)",
    width: 49.1,
    x: 581.1,
    y: 865.3
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    height: 61.1,
    rx: 24.6,
    ry: 24.6,
    transform: "translate(138.2 -175.2) rotate(15)",
    width: 49.1,
    x: 710,
    y: 406.7
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    height: 107.2,
    rx: 24.6,
    ry: 24.6,
    transform: "translate(114.7 -185.8) rotate(15)",
    width: 49.1,
    x: 738.5,
    y: 288.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignature2);
export default __webpack_public_path__ + "static/media/signature_2.c95589e3ae6b6368ab1ff38ec26a8d41.svg";
export { ForwardRef as ReactComponent };